import React from 'react'
import { Link } from 'react-router-dom'

// Der Weg zur aktuellen Seite als waagerechte Leiste. Seit die Abschnitte in
// eigener View liegen, ist die Station der Messe der Rueckweg zu den Kacheln —
// die Leiste ist damit Navigation, nicht nur Ortsangabe (#82).
//
// Eine Station ohne Ziel ist der Ort, an dem man steht. Eine mit extern
// verlaesst die React-App: dort muss ein gewoehnliches <a> stehen, sonst faengt
// react-router den Klick ab und die WordPress-Seite wird nie erreicht.
const Station = ({ label, to, extern }) => {
    if (!to) return <span aria-current="page">{label}</span>
    if (extern) return <a href={to}>{label}</a>

    return <Link to={to}>{label}</Link>
}

const EventBreadcrumb = ({ trail }) => {
    if (!trail.length) return null

    return (
        <nav className="event-breadcrumb" aria-label="Pfad">
            <ol>
                {trail.map(station => (
                    <li key={station.label}>
                        <Station {...station} />
                    </li>
                ))}
            </ol>
        </nav>
    )
}

export default EventBreadcrumb
